(() => {
  let pending = false;

  function draw() {
    pending = false;

    document.querySelectorAll('.jm-star-rating[aria-label]')
      .forEach(row => {
        const match = row.getAttribute('aria-label')
          .match(/^\s*(\d+(?:[.,]\d+)?)/);

        if (!match) return;
        const score = Number(match[1].replace(',', '.'));

        row.querySelectorAll('.jm-star-rating__font-icon')
          .forEach((star, index) => {
            const fill = Math.max(0, Math.min(1, score - index));

            if (
              star.dataset.sharpFill === String(fill) &&
              star.querySelector('svg')
            ) return;

            star.dataset.sharpFill = String(fill);

            const ns = 'http://www.w3.org/2000/svg';
            const svg = document.createElementNS(ns, 'svg');
            svg.setAttribute('viewBox', '0 0 24 24');
            svg.setAttribute('width', '16');
            svg.setAttribute('height', '16');
            svg.setAttribute('aria-hidden', 'true');
            svg.style.display = 'block';

            const base = document.createElementNS(ns, 'polygon');
            base.setAttribute(
  'points',
  '12,1 14.35,8.76 22.46,8.60 15.80,13.24 18.47,20.90 12,16 5.53,20.90 8.20,13.24 1.54,8.60 9.65,8.76'
);
            base.setAttribute('fill', '#D6D0CB');

            const gold = base.cloneNode();
            gold.setAttribute('fill', '#E3AC24');
            gold.style.clipPath =
              `inset(0 ${(1 - fill) * 100}% 0 0)`;

            svg.append(base, gold);
            star.replaceChildren(svg);
          });
      });
  }

  new MutationObserver(() => {
    if (!pending) {
      pending = true;
      requestAnimationFrame(draw);
    }
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-label']
  });

  draw();
})();
const starStyle = document.createElement('style');
starStyle.textContent = `
  .jm-star-rating .jm-cluster {
    gap: 1px !important;
  }

  .jm-star-rating__font-icon {
    display: inline-flex !important;
    width: 17px !important;
    height: 17px !important;
    margin: 0 !important;
    padding: 0 !important;
    flex-shrink: 0;
  }

  .jm-star-rating__font-icon svg {
    display: block;
    width: 16px;
    height: 16px;
  }
`;
document.head.appendChild(starStyle);
const reviewStyle = document.createElement('style');
reviewStyle.textContent = `
  .sf-judge-reviews .jdgm-review-card {
    border-radius: 14px !important;
    overflow: hidden;
    background: transparent !important;
  }

  .sf-judge-reviews .jdgm-review-card__content {
    background: transparent !important;
  }
`;
document.head.appendChild(reviewStyle);